import queryStringBuilder from '../../utils/queryStringBuilder';

const API_URL = process.env.API_URL;
const jwt = () => localStorage.getItem('jwt');

export const getCustomers = (queries) =>
    fetch(`${API_URL}/customer?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getCustomer = (customerId) =>
    fetch(`${API_URL}/customer/${customerId}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getCustomerLeads = (customerId, queries) =>
    fetch(`${API_URL}/customer/${customerId}/leads?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })


export const createCustomer = (customer) =>
    fetch(`${API_URL}/customer`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(customer)
    })

export const updateCustomer = (customerId, customer) =>
    fetch(`${API_URL}/customer/${customerId}`, {
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(customer)
    })

export const deleteCustomers = (customerIds) =>
    fetch(`${API_URL}/customer/batch-delete`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify({ customerIds })
    })

export const getCustomersLatestConsultant = (customerIds) =>
    fetch(`${API_URL}/customer/latest-consultant?customer_ids=${customerIds.join(',')}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const mergeCustomers = (originalCustomerIds, newCustomerId) =>
    fetch(`${API_URL}/customer/merge`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify({ originalCustomerIds, newCustomerId })
    })

export const getOverallDistribution = (queries) =>
    fetch(`${API_URL}/customer/overall-distribution?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getLeadDistribution = (queries) =>
    fetch(`${API_URL}/customer/lead-distribution?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getEnrollmentDistribution = (queries) =>
    fetch(`${API_URL}/customer/enrollment-distribution?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getRanking = (queries) =>
    fetch(`${API_URL}/customer/ranking?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const unlockCustomer = (customerId) =>
    fetch(`${API_URL}/customer/${customerId}/unlock`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const searchCustomers = (query) =>
    fetch(`${API_URL}/customer?query=${query}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })


// WEBPACK FOOTER //
// ./src/services/api/customer.js